import { render, staticRenderFns } from "./AccessManagementSpreadForm.vue?vue&type=template&id=f2ad3b36"
import script from "./AccessManagementSpreadForm.vue?vue&type=script&lang=js"
export * from "./AccessManagementSpreadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2ad3b36')) {
      api.createRecord('f2ad3b36', component.options)
    } else {
      api.reload('f2ad3b36', component.options)
    }
    module.hot.accept("./AccessManagementSpreadForm.vue?vue&type=template&id=f2ad3b36", function () {
      api.rerender('f2ad3b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/spread-viewer-access-options/AccessManagementSpreadForm.vue"
export default component.exports